import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { TopBar } from "@/components/layout/TopBar";
import { atLeast, ROLE_LABELS, type RoleName } from "@/lib/roles";
import { useAuth } from "@/lib/auth";

/** Route guard: renders the page for `min` and above, a plain
 *  "no access" panel otherwise (never a blank page, never a 404). */
export function RequireRole({ min, children }: { min: RoleName; children: ReactNode }) {
  const { user } = useAuth();
  if (atLeast(user?.role, min)) return <>{children}</>;
  return (
    <>
      <TopBar title="No access" />
      <div className="p-8" data-testid="no-access">
        <div className="mx-auto max-w-md rounded-xl border border-line bg-surface p-8 text-center">
          <ShieldOff className="mx-auto mb-3 h-6 w-6 text-ink-subtle" />
          <p className="text-sm text-ink">This page needs the <strong>{ROLE_LABELS[min]}</strong> role.</p>
          <p className="mt-1 text-xs text-ink-muted">Your account is <strong>{ROLE_LABELS[(user?.role as RoleName) ?? "viewer"]}</strong>. Ask the PMO if you need it changed.</p>
          <Link to="/executive" className="mt-4 inline-block text-xs font-medium text-brand-navy-600 dark:text-brand-navy-400 hover:underline">Back to Executive</Link>
        </div>
      </div>
    </>
  );
}
